import { render, staticRenderFns } from "./tabImages.vue?vue&type=template&id=4a340cc4"
import script from "./tabImages.vue?vue&type=script&lang=js"
export * from "./tabImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports